
import { MessageSquareOff } from 'lucide-react';

interface EmptyStateProps {
  message: string;
  subMessage?: string;
}

const EmptyState = ({ message, subMessage }: EmptyStateProps) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-[#1e1e2d] transition-colors">
      <div className="w-16 h-16 rounded-full bg-gray-200 dark:bg-gray-700/50 flex items-center justify-center mb-4">
        <MessageSquareOff className="h-8 w-8 text-gray-500 dark:text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-700 dark:text-gray-300 text-center">
        {message}
      </h3>
      {subMessage && (
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-500 text-center">
          {subMessage}
        </p>
      )}
    </div>
  );
};

export default EmptyState;
